import d from "classnames";
import a, { useMemo as z } from "react";
import { useSizeAttrs as L } from "../utils/hooks/useSizeAttrs.esm.js";
const x = "_link_11olb_1 _tappableArea_1kc19_1", B = "_link__icon_11olb_261", o = {
  link: x,
  link__icon: B
}, F = ({
  as: c = "a",
  centreAlign: _ = !1,
  children: m = null,
  className: u,
  dataTestId: f = null,
  disabled: s,
  href: k,
  icon: e,
  iconRight: t = !1,
  chevron: l = !1,
  iconColour: p,
  isButton: i = !1,
  size: v = "large",
  standalone: b = !1,
  underline: N = !0,
  white: E = !1,
  focusable: g = !1,
  fullWidth: y = !1,
  ...A
}) => {
  const w = L(v, {}), n = i ? "button" : c, r = z(() => l ? /* @__PURE__ */ a.createElement("span", { className: o.link__icon }) : e ? a.cloneElement(e, {
    className: d(o.link__icon, e.props.className)
  }) : null, [e, l]);
  return a.createElement(
    n,
    {
      "aria-disabled": s ? "" : void 0,
      className: d(o.link, u),
      "data-testid": f,
      href: s || i || n === "span" ? void 0 : k,
      role: n === "button" ? "button" : "link",
      ...w,
      "data-icon": e || l ? "" : void 0,
      "data-chevron": l ? "" : void 0,
      "data-icon-right": t ? "" : void 0,
      "data-underline": N ? "" : void 0,
      "data-standalone": b ? "" : void 0,
      "data-centre-align": _ ? "" : void 0,
      "data-focusable": g ? "" : void 0,
      "data-full-width": y ? "" : void 0,
      style: {
        "--link-color-override": E ? "var(--color-global-white)" : "",
        "--link-icon-colour": p
      },
      ...A
    },
    /* @__PURE__ */ a.createElement(a.Fragment, null, !t && r, m, t && r)
  );
};
F.displayName = "BaseLink";
export {
  F as BaseLink
};
